import { DateNumber } from "types/global"
import { diffDay, shiftDays } from "utils/time"
import { Activity, GROUP_SHOW_TYPE, GraphGroup, GraphRect, GraphStyle } from "../types"
import { xFromTimeStyled } from "./time"
import { groupsHeightForEach } from "./groups"




/** [II] da cambiare in punti solo relativi alla griglia
 * Restituisce un rect cioe' due punti TEMPORALI per le X e celle per le Y 
 * {p1x,p1y,p2x,p2y}
 * del rettangolo che include tutte le action passate come parametro
 */
export function getRect(activities: Activity[]): GraphRect {
	if (!activities || !Array.isArray(activities) || activities.length == 0) return null
	return activities.reduce((acc, activity) => ({
		p1x: Math.min(acc.p1x, activity.start),
		p1y: Math.min(acc.p1y, activity.row),
		p2x: Math.max(acc.p2x, shiftDays(activity.start, activity.length)),
		p2y: Math.max(acc.p2y, activity.row + 1),
	}), { p1x: Number.MAX_SAFE_INTEGER, p1y: Number.MAX_SAFE_INTEGER, p2x: Number.MIN_SAFE_INTEGER, p2y: Number.MIN_SAFE_INTEGER })
}

/**
 * Date delle "activities" le cerco nei "groups"  
 * e in relazione alla data di start  
 * restituisco un array dei loro RECT nel PLANNER
  */
export function getRectsFromActivities(
	activitiesSelect: Activity[],
	groups: GraphGroup[],
	dateStart: DateNumber,
	style: GraphStyle,

): { rects?: GraphRect[], timeMin?: number, timeMax?: number } {
	if (!activitiesSelect) return {}

	const xFromTime = xFromTimeStyled(style, dateStart)
	let timeMin = Number.MAX_SAFE_INTEGER, timeMax = Number.MIN_SAFE_INTEGER
	let rects: GraphRect[] = []

	// ciclo tutti i GROUP
	groupsHeightForEach(groups, style, (group, y, height, collapsed) => {
		if (group.unselectable || !group.activities) return

		// prendo tutte le ACTIVITIES del GROUP che sono state selezionate
		const activities = group.activities.filter(a => activitiesSelect.includes(a))

		// get il RECT delle ACTIVITIES di uno specifico GROUP
		let rect = getRect(activities)
		if (!rect) return
		timeMin = Math.min(timeMin, rect.p1x)
		timeMax = Math.max(timeMax, rect.p2x)
		rect.p1x = xFromTime(rect.p1x)
		rect.p2x = xFromTime(rect.p2x)

		const yHeight = group.show == GROUP_SHOW_TYPE.COMPACT ? style.compact.y : style.space.y
		const headHeigth = group.show == GROUP_SHOW_TYPE.COMPACT ? 0 : style.header.height
		rect.p1y = y + headHeigth + (collapsed ? 0 : rect.p1y * yHeight)
		rect.p2y = y + headHeigth + (collapsed ? 0 : rect.p2y * yHeight)
		rect.activities = activities
		rect.group = group
		rect.collapsed = collapsed
		rects.push(rect)
	})
	// prendo solo i RECT non null
	// e metto in ordine i RECT in base a chi "avviene prima"
	rects = rects
		.filter(rect => rect)
		.sort((rect1, rect2) => {
			return rect1.p1x - rect2.p1x
		})

	return { rects, timeMin, timeMax }
}

/**
 * dati dei "rects" li traslo di una certa data e un certo y
 */
export function translateRects(
	rects: GraphRect[],
	scrollY: number,
	dateStart: DateNumber,
	dateCurrent: DateNumber,
	style: GraphStyle,

): GraphRect[] {
	if (!rects) return []

	const diff = diffDay(dateCurrent, dateStart) * style.space.x
	for (const r of rects) {
		r.p1y += scrollY
		r.p2y += scrollY
		r.p1x -= diff
		r.p2x -= diff
	}

	return rects
}